export const LEAD_SOURCES = {
    website_inbound: 'Website / Inbound',
    client_referral: 'Client Referral',
    partner_referral: 'Partner Referral',
    employee_personal_referral: 'Employee / Personal Referral',
    existing_customer: 'Existing Customer',
    outbound_email: 'Outbound Email',
    outbound_call: 'Outbound Call',
    linkedin: 'LinkedIn',
    organic_search_seo: 'Organic Search / SEO',
    paid_advertising: 'Paid Advertising',
    trade_show_event: 'Trade Show / Event',
    technology_partner: 'Technology Partner',
    agency_channel_partner: 'Agency / Channel Partner',
    rfp_bid: 'RFP / Bid',
    other: 'Other',
};

export const LEAD_SOURCE_ORDER = Object.keys(LEAD_SOURCES);

/** Legacy keys from earlier builds — display-friendly fallback */
const LEGACY_LEAD_SOURCE_LABELS = {
    website_form: 'Website Form',
    referral: 'Referral',
    cold_outreach: 'Cold Call / Cold Email',
    linkedin_social: 'LinkedIn / Social Media',
    google_ads: 'Google Ads / Paid Campaign',
    trade_show: 'Trade Show / Event',
    website: 'Website Form',
    partner: 'Partner Referral',
    campaign: 'Google Ads / Paid Campaign',
};

export function getLeadSourceLabel(key) {
    return LEAD_SOURCES[key] || LEGACY_LEAD_SOURCE_LABELS[key] || key;
}
